export const buyItAllAssets = {
	badge: "/spec_buy_it_all/badge-buy-it-all-button.png",
	fingerPointer: "/spec_buy_it_all/finger-pointer-icon.png"
} as const;
